import React from 'react';
import { Droplets, Gem, Sparkles, BedDouble } from 'lucide-react';
import { formatMoney } from './calc';

const ICONS = {
  regular: Droplets,
  deep: Gem,
  maid_standard: Sparkles,
  maid_linen: BedDouble,
};

const ServiceStep = ({ config, draft, updateDraft, nextStep }) => {
  const minPrice = (key) => {
    const opts = config.sqft_options;
    if (key === 'deep') return `From ${formatMoney(opts[0].deep_price)}`;
    return `From ${formatMoney(opts[0].regular_price)}`;
  };

  return (
    <div className="form-step" data-testid="service-step">
      <h2 className="step-title">Choose Your Service</h2>
      <p className="step-description">Select the cleaning service that fits your needs</p>

      <div className="service-cards" data-testid="service-cards">
        {config.services.map((svc) => {
          const Icon = ICONS[svc.key] || Sparkles;
          return (
            <button
              type="button"
              key={svc.key}
              className={`service-select-card ${draft.service_type === svc.key ? 'selected' : ''}`}
              onClick={() => updateDraft({ service_type: svc.key })}
              data-testid={`service-${svc.key}`}
            >
              <div className="service-select-icon"><Icon size={22} strokeWidth={1.5} /></div>
              <div className="service-select-info">
                <span className="service-select-name">{svc.label}</span>
                <span className="service-select-desc">{svc.description}</span>
              </div>
              <span className="service-select-price">
                {svc.pricing === 'flat' ? formatMoney(svc.price) : minPrice(svc.key)}
              </span>
            </button>
          );
        })}
      </div>

      <div className="form-actions">
        <span />
        <button
          type="button"
          className="btn btn-primary"
          disabled={!draft.service_type}
          onClick={nextStep}
          data-testid="service-step-next"
        >
          Continue
        </button>
      </div>
    </div>
  );
};

export default ServiceStep;
